import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { flowVasActionTypes } from '../types/flowVasActionTypes'
import { FlowVas } from '../../interfaces/FlowVas/FlowVas'
import { getFlowVasAction } from '../actions/flowVasAction'

export function* getFlowVasAsync() {
  try {
    const { status, data }: AxiosResponse<FlowVas[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.FlowVasApi}/GetDdlInfo`
    )

    if (status === 200) {
      yield put(getFlowVasAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getFlowVasAction([], serverError.message))
  }
}

export function* watchGetFlowVasAsync() {
  yield takeEvery(flowVasActionTypes.GET_FLOW_VAS, getFlowVasAsync)
}
